/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SettingsSlidersH3Icon16Solid = forwardRef('SettingsSlidersH3Icon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2 5h6.875a2.125 2.125 0 0 0 3.75 0H14a1 1 0 1 0 0-2h-1.374a2.125 2.125 0 0 0-3.751 0H2a1 1 0 0 0 0 2Z" }),
        React.createElement("path", { d: "M2 7a1 1 0 0 0 0 2h1.374a2.125 2.125 0 0 0 3.752 0H14a1 1 0 1 0 0-2H7.126a2.125 2.125 0 0 0-3.752 0H2Z" }),
        React.createElement("path", { d: "M2 11a1 1 0 1 0 0 2h6.875a2.125 2.125 0 0 0 3.75 0H14a1 1 0 1 0 0-2h-1.374a2.125 2.125 0 0 0-3.751 0H2Z" })));
});
